var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell-group',_vm._l((_vm.list),function(item,index){return _c('van-cell',{key:index,attrs:{"title":"订单-收入","value":item.price}})}),1),_vm._v(" "),_c('Floating'),_vm._v(" "),_c('wxNoShare')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73546c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/income.vue
// module id = null
// module chunks = 